export {
  buildHeaderRows,
  type ITableCollection,
  TableCollection
} from '../../../src/table/TableCollection';
